const HTTP_STATUS_FALLBACK_MESSAGES: Record<number, string> = {
  400: "请求参数有误，请检查输入内容",
  401: "登录已过期，请重新登录",
  403: "没有权限执行该操作",
  404: "请求的接口不存在",
  409: "数据冲突，请刷新页面后重试",
  422: "提交数据校验失败，请检查输入内容",
  429: "请求过于频繁，请稍后再试",
  500: "服务器开小差了，请稍后重试",
  502: "服务暂时不可用，请稍后重试",
  503: "服务暂时不可用，请稍后重试",
  504: "服务响应超时，请稍后重试",
};

const GENERIC_HTTP_MESSAGES = [
  "bad request",
  "unauthorized",
  "forbidden",
  "not found",
  "internal server error",
  "request failed",
  "request error, please retry.",
  "none response! please retry.",
];

const isMeaningfulMessage = (value: unknown): value is string => {
  if (typeof value !== "string") {
    return false;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return false;
  }

  const normalized = trimmed.toLowerCase();
  if (GENERIC_HTTP_MESSAGES.includes(normalized)) {
    return false;
  }

  if (/^\d{3}$/.test(trimmed)) {
    return false;
  }

  if (/^request failed with status code \d{3}$/i.test(trimmed)) {
    return false;
  }

  if (/^response status:.*-\d{3}$/i.test(trimmed)) {
    return false;
  }

  return true;
};

export const getHttpStatusFallbackMessage = (
  status?: number,
  fallback = "请求失败，请稍后重试"
): string => {
  if (typeof status === "number" && HTTP_STATUS_FALLBACK_MESSAGES[status]) {
    return HTTP_STATUS_FALLBACK_MESSAGES[status];
  }
  return fallback;
};

export const getRequestErrorMessage = (
  error: unknown,
  fallback = "请求失败，请稍后重试"
): string => {
  if (isMeaningfulMessage(error)) {
    return error.trim();
  }

  const err = error as any;
  const candidates = [
    err?.info?.message,
    err?.response?.data?.message,
    err?.response?.data?.error?.message,
    err?.data?.message,
    err?.message,
  ];

  for (const candidate of candidates) {
    if (isMeaningfulMessage(candidate)) {
      return candidate.trim();
    }
  }

  const status = err?.response?.status;
  return getHttpStatusFallbackMessage(status, fallback);
};
